
import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';
import { colorPrimary, colorPink, colorLightPink, colorBorder, textColor, neutralBlack } from '../../Styles/Colors';

const VARIANT_MAP = {
  success: {
    bg: '#e6f4ea',
    border: '#4caf50',
    color: '#256029',
    icon: <CheckCircleIcon sx={{ color: '#4caf50' }} />,
  },
  error: {
    bg: '#fbeaea',
    border: '#f44336',
    color: '#a31515',
    icon: <ErrorIcon sx={{ color: '#f44336' }} />,
  },
  warning: {
    bg: '#fff4e5',
    border: '#ff9800',
    color: '#7c4a02',
    icon: <WarningIcon sx={{ color: '#ff9800' }} />,
  },
  info: {
    bg: '#e8f0fe',
    border: '#2196f3',
    color: '#174ea6',
    icon: <InfoIcon sx={{ color: '#2196f3' }} />,
  },
  neutral: {
    bg: '#f4f4f4',
    border: colorBorder,
    color: neutralBlack,
    icon: null,
  },
};

 
const Alert = ({
  variant = 'info',
  title = '',
  description = 'This is a description for the alert message.',
  outlined = false,
  showIcon = true,
  node,
  ...props
}) => {
  const config = VARIANT_MAP[variant] || VARIANT_MAP.info;
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '10px 24px',
        background: config.bg,
        border: outlined ? `1.5px solid ${config.border}` : 'none',
        borderRadius: '8px',
        minHeight: 36,
        width: '100%',
        alignSelf: 'stretch',
        ...node?.style,
      }}
      {...props}
    >
      {showIcon && config.icon}
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant="body2" sx={{ color: config.color, fontWeight: 600, fontSize: 14, ...node?.Text?.style }}>
          {node?.Text?.label || 'Alert Title'}
        </Typography>
        {description && (
          <Typography variant="caption" sx={{ color: config.color, fontSize: 12 }}>
            {description || 'This is a description for the alert message.'}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default Alert;
